export default {
  path: "/callback",
  name: "Callback",
  component: () => import("../views/layouts/Blank.layout.vue"),
  meta: {
    requiresAuth: false,
  },
  children: [
    {
      path: "/",
      name: "CallbackProd",
      component: () => import("../views/pages/Login/Callback.page.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "uat",
      name: "CallbackUat",
      component: () => import("../views/pages/Login/CallbackUat.page.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "demo",
      name: "CallbackDemo",
      component: () => import("../views/pages/Login/CallbackDemo.page.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "mobile",
      name: "CallbackMobile",
      component: () => import("../views/pages/Login/CallbackMobile.page.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "line",
      name: "CallbackLine",
      component: () => import("../views/pages/Login/CallbackLine.page.vue"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
};
